module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921001149_T.b78262dc.jpg";